import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

// utils
import { allowNav } from '../../../../utils/allow-nav';

function NavLockIndicator() {
  const { pathname } = useLocation();
  const {
    telephony: { status },
    theme: { telephony, inPersonTelephony, allowNavOnlyInCall },
    enrollment: { submittedFlag },
  } = useSelector(store => store);

  const te = Boolean(telephony || inPersonTelephony);
  const navEnabled = allowNav({ allowNavOnlyInCall, submitted: submittedFlag, callStatus: status });
  const isFirstTelephonyRoute = pathname.includes('telephony/prepare');

  if (te && !navEnabled && !isFirstTelephonyRoute) {
    return (
      <div
        className="text-danger fs-5 fw-bold"
        style={{
          position: 'fixed',
          zIndex: '9',
          bottom: '70px',
          left: '36%',
          width: '400px',
          height: '30px',
          display: 'flex',
          alignItems: 'center',
          background: 'rgba(255, 255, 255, 0.9)',
          boxShadow: '0px 0px 10px 10px white',
        }}
      >
        You must be connected to a call to proceed
      </div>
    );
  }
  return null;
}

export default NavLockIndicator;
